<template>
    <div v-if="show" class="flex flex-wrap mt-0 md:mt-4 mb-0 md:mb-1">
        <div class="text-xs sm:text-sm font-semibold mr-1">Go to:</div>
        <a @click.prevent="handleScroll(commodity.scrollTo)" v-for="commodity in commodities" href="#" class="align-middle text-xs sm:text-sm pr-4 font-semibold cursor-pointer">
            {{ commodity.label }}
        </a>
    </div>
</template>

<script setup>
import { onMounted, ref, watch, computed, getCurrentInstance, inject } from 'vue';

const props = defineProps({
    isMiniMicro: {
        type: Boolean,
        default: false,
    },
});

const { appContext } = getCurrentInstance();
const show = ref(true);

const eventBus = inject('eventBus');

const commodities = ref([
    { label: 'Grains', scrollTo: 'grains' },
    { label: 'Metals', scrollTo: 'metals' },
    { label: 'Currencies', scrollTo: 'currencies' },
    { label: 'Energies', scrollTo: 'energies' },
    { label: 'Financials', scrollTo: 'financials' },
    { label: 'Meats', scrollTo: 'meats' },
    { label: 'Foods/Softs', scrollTo: 'foods-softs' },
    { label: 'Indices', scrollTo: 'indices' },
]);

if (props.isMiniMicro) {
    commodities.value.push({ label: 'Mini/Micro', scrollTo: 'mini-micro' });
}

const offset = computed(() => {
    const thead = document.querySelector('table.table thead');
    return thead ? thead.getBoundingClientRect().height * -1 : 0;
});

const updateCommodity = (scrollTo) => {
    window.location.href = `#${scrollTo}`;
};

const handleSort = (newRequestSettings) => {
    if (newRequestSettings.groupBy === 'symbolName') {
        show.value = false;
    } else {
        show.value = true;
    }
};

const handleScroll = (element) => {
    const options = {
        offset: offset.value,
        container: document.body,
    };
    appContext.app.config.globalProperties.$scrollTo(`#${element}`, undefined, options);
};


onMounted(() => {
    eventBus.on('sortBy', handleSort);

    eventBus.on('toggle-navigation', (isShow) => {
        if (isShow) {
            show.value = (isShow == 'show');
        } else {
            show.value = !show.value;
        }
    });
});

watch(show, (newShow, oldShow) => {
    if (newShow !== oldShow) {
        eventBus.emit('navigation-toggled', newShow);
    }
});
</script>
